// @flow
import React from 'react'
import cx from 'classnames'

import { useStatusBadgeStyles } from './styles'

type StatusBadgeProps = {
  type?: 'success' | 'danger' | 'warning',
  text: string
}

const StatusBadge = ({ type = 'success', text, ...props }: StatusBadgeProps) => {
  const classes = useStatusBadgeStyles()
  return (
    <div {...props} className={classes.statusBadge}>
      <span className={cx(classes.dot, type)} />
      <span>{text}</span>
    </div>
  )
}

export { StatusBadge }
